function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#search_icon_svg__filter0_d_115_1208)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.6 18l-6.3-6.3a6.096 6.096 0 01-3.8 1.3c-1.817 0-3.354-.63-4.612-1.888C4.63 9.853 4.001 8.316 4 6.5c0-1.817.63-3.354 1.888-4.612C7.147.63 8.684.001 10.5 0c1.817 0 3.354.63 4.613 1.888C16.372 3.147 17.001 4.684 17 6.5a6.096 6.096 0 01-1.3 3.8l6.3 6.3-1.4 1.4zm-10.1-7c1.25 0 2.313-.437 3.188-1.312S15.001 7.751 15 6.5c0-1.25-.437-2.312-1.312-3.187S11.751 2.001 10.5 2c-1.25 0-2.312.438-3.187 1.313S6.001 5.251 6 6.5c0 1.25.438 2.313 1.313 3.188S9.251 11.001 10.5 11z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "search_icon_svg__filter0_d_115_1208",
  x: 0,
  y: 0,
  width: 26,
  height: 26,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_115_1208"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_115_1208",
  result: "shape"
})));

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSearchIcon;